import React, { useState } from "react"
import { motion } from "framer-motion"
import ChevronLeft from "../../Shared/ChevronLeft"
import "./DropdownNavItem.scss"

const DropdownNavItem = ({ options, name }) => {
  const [open, setOpen] = useState(false)

  return (
    <div
      className="dropdown-nav-item-wrapper"
      onMouseOver={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <div
        className={`dropdown-nav-item-name ${
          open ? "dropdown-nav-item-name__active" : ""
        }`}
      >
        <span>{name}</span>
        <ChevronLeft className="dropdown-nav-item-chevron" />
      </div>
      <motion.div
        className="dropdown-nav-item-list"
        initial="closed"
        exit="closed"
        animate={open ? "open" : "closed"}
        variants={{
          closed: {
            opacity: 0,
            pointerEvents: "none",
            transition: {
              type: "spring",
              duration: 0.5,
              delay: 0.15,
            },
          },
          open: {
            opacity: 1,
            pointerEvents: "auto",
            transition: {
              type: "spring",
              duration: 0.5,
            },
          },
        }}
      >
        <span>Multiplayer Everything</span>
        <ul>
          {options.map(({ name, link, icon, onClick }) => (
            <li key={name}>
              <a href={link} target="_blank" onClick={onClick}>
                {icon}
                {name}
              </a>
            </li>
          ))}
        </ul>
      </motion.div>
    </div>
  )
}

export default DropdownNavItem
